import React, { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const CaseStudiesPage = lazy(() => import('../pages/case-studies/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const HVACMaintenanceCostsPage = lazy(() => import('../pages/blog/hvac-maintenance-costs/page'));
const ReactiveMaintenanceCostsPage = lazy(() => import('../pages/blog/reactive-maintenance-costs/page'));
const ReactivePowerPowerFactorPage = lazy(() => import('../pages/blog/reactive-power-power-factor/page'));
const HarmonicsVsPowerFactorPage = lazy(() => import('../pages/blog/harmonics-vs-power-factor/page'));
const HVACSmartChipOptimizationPage = lazy(() => import('../pages/blog/hvac-smart-chip-optimization/page'));
const LEDLightingROIComparisonPage = lazy(() => import('../pages/blog/led-lighting-roi-comparison/page'));
const EnergyBenchmarkingPeakDemandPage = lazy(() => import('../pages/blog/energy-benchmarking-peak-demand/page'));
const RestaurantEnergyEfficiencyPage = lazy(() => import('../pages/blog/restaurant-energy-efficiency/page'));
const SmartBuildingTechnologyPage = lazy(() => import('../pages/blog/smart-building-technology/page'));
const CarDealershipEnergyLoadsPage = lazy(() => import('../pages/blog/car-dealership-energy-loads/page'));
const ActiveEnergyManagementPage = lazy(() => import('../pages/blog/active-energy-management/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const IndustriesPage = lazy(() => import('../pages/industries/page'));
const RestaurantIndustryPage = lazy(() => import('../pages/industries/restaurants/page'));
const ManufacturingIndustryPage = lazy(() => import('../pages/industries/manufacturing/page'));
const MunicipalitiesIndustryPage = lazy(() => import('../pages/industries/municipalities/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/services',
    element: <ServicesPage />,
  },
  {
    path: '/case-studies',
    element: <CaseStudiesPage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/blog',
    element: <BlogPage />,
  },
  {
    path: '/blog/hvac-maintenance-costs',
    element: <HVACMaintenanceCostsPage />,
  },
  {
    path: '/blog/reactive-maintenance-costs',
    element: <ReactiveMaintenanceCostsPage />,
  },
  {
    path: '/blog/reactive-power-power-factor',
    element: <ReactivePowerPowerFactorPage />,
  },
  {
    path: '/blog/harmonics-vs-power-factor',
    element: <HarmonicsVsPowerFactorPage />,
  },
  {
    path: '/blog/hvac-smart-chip-optimization',
    element: <HVACSmartChipOptimizationPage />,
  },
  {
    path: '/blog/led-lighting-roi-comparison',
    element: <LEDLightingROIComparisonPage />,
  },
  {
    path: '/blog/energy-benchmarking-peak-demand',
    element: <EnergyBenchmarkingPeakDemandPage />,
  },
  {
    path: '/blog/restaurant-energy-efficiency',
    element: <RestaurantEnergyEfficiencyPage />,
  },
  {
    path: '/blog/smart-building-technology',
    element: <SmartBuildingTechnologyPage />,
  },
  {
    path: '/blog/car-dealership-energy-loads',
    element: <CarDealershipEnergyLoadsPage />,
  },
  {
    path: '/blog/active-energy-management',
    element: <ActiveEnergyManagementPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/industries',
    element: <IndustriesPage />,
  },
  {
    path: '/industries/restaurants',
    element: <RestaurantIndustryPage />,
  },
  {
    path: '/industries/manufacturing',
    element: <ManufacturingIndustryPage />,
  },
  {
    path: '/industries/municipalities',
    element: <MunicipalitiesIndustryPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
